// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".store-locator-select_reset .el-select__caret{color:var(--primary-500)!important;font-size:.18rem!important;font-weight:700}.store-locator-select_reset .el-input.is-focus .el-input__inner{border-color:var(--primary-500)!important}.store-locator-select_reset .el-input__inner{color:#000}.store-locator-select_reset .el-input__inner:focus{border-color:var(--primary-500)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
